import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

const rootDOM = document.getElementById('root')
const root = createRoot(rootDOM)

root.render(<App />)
